import { APICore } from 'data/api/apiCore';
import { User } from 'data/types';

export default function useUser(): [User | null] {
    const api = new APICore();

    const user = api.getLoggedInUser();
    return [user];
}
